enum ROL_IDS {
  ADMIN = '3da36a6d-2d57-4318-b504-842d957787e2',
  USER = 'ae5c2798-3e76-4667-a8b4-8d04234f5f2a'
}

export {
  ROL_IDS,
};
